import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBuefyComponent } from './simple-icons-buefy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBuefyComponent ],
    exports:      [ SimpleIconsBuefyComponent ],
    bootstrap:    []
})
export class SimpleIconsBuefyModule {}
